import { render, staticRenderFns } from "./VueDataTableIconTooltip.vue?vue&type=template&id=0b056620&scoped=true"
import script from "./VueDataTableIconTooltip.vue?vue&type=script&lang=js"
export * from "./VueDataTableIconTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b056620",
  null
  
)

export default component.exports